import { useIconProps } from './utils/use-icon-props';
import { makeIconComponent } from './utils/make-icon-component';
import Icons, { createIcons } from './core';
export default Icons;
export { createIcons, useIconProps, makeIconComponent };